<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="fabricCode"
      cell-class-name="align-top"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :seq-config="{ startIndex: 0 }"
    >
      <template v-slot:fabricColorTitle="{ row }">
         <span>{{ row.sampleStyleNo }}</span>
        <br />
        <span>{{ row.sampleSpecName }}</span>
      </template>
      <template v-slot:fabricColorSize="{ row }">
        <span>{{ row.goodsSpec }}</span>
        <!-- <br />
        <span>{{ row.fabricColorTitle }}</span>
        <br />
        <span>{{ row.fabricColorTitleEn }}</span> -->
      </template>
      <template v-slot:fabricPosition="{ row }">
        <div
          v-for="(item, index) in row.positionInfos"
          :key="index + Math.random()"
        >
          {{ `${item.fabricPositionName || ''} ${item.fabricContent || ''}` }}
        </div>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width: 100px; height: 66px"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {},
}
</script>
